export const GET_TRANSLATIONS = 'GET_TRANSLATIONS';
export const GET_TRANSLATIONS_REQUEST = 'GET_TRANSLATIONS_REQUEST';
export const GET_TRANSLATIONS_SUCCESS = 'GET_TRANSLATIONS_SUCCESS';
export const GET_TRANSLATIONS_CACHE = 'GET_TRANSLATIONS_CACHE';
export const GET_TRANSLATIONS_FAIL = 'GET_TRANSLATIONS_FAIL';
